import { default as BaseAxios } from "axios";

class RequestClass {
  constructor() {
    this.axios = BaseAxios.create({ timeout: 60000 });
  }

  async call(config) {
    try {
      const serverBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
      let headers = {
        Accept: "application/json",
        "Content-Type": config?.multipart
          ? "multipart/form-data"
          : "application/json",
      };

      // TODO: add the authorization token in header for the private routes

      const res = await this.axios.request({
        baseURL: serverBaseUrl,
        headers,
        ...config,
      });
      return { ...res.data, succeed: true };
    } catch (error) {
      // TODO: identify the api error message field and replace with the data
      const {
        response: { status, data },
      } = error;
      return {
        succeed: false,
        status,
        data,
      };
    }
  }
}

const Request = new RequestClass();
export { Request };
